import i18n from 'src/typescript/servicos/i18n/i18n.servico'
import moment from 'moment'
import {
  obterValorLimiteHorasTrabalhadas,
  obterApontamentosSelecionadosLimiteHorasTrabalhadas,
  obterJornadaBaseLimiteHorasTrabalhadas,
  OPCOES_DE_APONTAMENTOS
} from './limiteDeAcumuloPorHorasTrabalhadas'
import {
  obterCriteriosSelecionados,
  obterOpcoesDeTipoDeAcumuloDaBaixaDeBh,
  OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH
} from './compensacaoEmOrdem'

function converteStringParaDate (string) {
  if (!string) return null
  return moment(string).toDate()
}

function formataTipoDoCicloDeAutoCompensacao (tipoDoCicloDeAutoCompensacao) {
  const opcoes = [
    {
      id: 'month',
      name: i18n.t('hourBankRules.details.state.comuns.opcoesAutoCompensacao.mensal')
    },
    {
      id: 'week',
      name: i18n.t('hourBankRules.details.state.comuns.opcoesAutoCompensacao.semanal')
    },
    {
      id: 'days',
      name: i18n.t('hourBankRules.details.state.comuns.opcoesAutoCompensacao.diaria')
    }
  ]
  return {
    loaded: opcoes,
    selected: opcoes.find(v => v.id === tipoDoCicloDeAutoCompensacao)
  }
}

function formataCamposDesconsideradosGatilhoMensal (camposDesconsideradosGatilhoMensal) {
  if (!camposDesconsideradosGatilhoMensal) return []

  const campos = [
    { id: 'extra_time_50_tot', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.horaExtra') },
    { id: 'extra_time_100_tot', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.horaExtraExtraordinaria') },
    { id: 'extra_time_special_tot', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.horaExtraEspecial') },
    { id: 'delay_time', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.atraso') },
    { id: 'early_exit', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.saidaAntecipada') },
    { id: 'lunch_penalty', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.atrasoPausa') },
    { id: 'absence_hours', name: i18n.t('hourBankRules.comuns.camposDesconsideradosGatilhoMensal.horasFaltas') }
  ]

  return camposDesconsideradosGatilhoMensal.map(id => campos.find(campo => id === campo.id))
}

function converteValorMinimo (valor, indice) {
  const indicesIgnorados = [3, 8]
  if (indicesIgnorados.includes(indice)) return -1
  if (indice === 9) return valor === -1 ? null : valor
  if (valor === -1) return 0
  return valor
}

function converteValorMaximo (valor) {
  if (valor === -1) return null
  return valor
}

function formataModalidadeDoBanco (autoCompensate) {
  const opcoes = [
    { id: 'geral', name: i18n.t('hourBankRules.DetalhesDaTabela.opcoesSelecao.compensacaoGeral') },
    { id: 'janela', name: i18n.t('hourBankRules.comuns.modalidadesDoBanco.compensacaoJanela') }
  ]
  const REPRESENTACAO_NO_SELECT_PARA_ESTADO = {
    'true': { id: 'janela', name: i18n.t('hourBankRules.comuns.modalidadesDoBanco.compensacaoJanela') },
    'false': { id: 'geral', name: i18n.t('hourBankRules.DetalhesDaTabela.opcoesSelecao.compensacaoGeral') }
  }

  return {
    selected: REPRESENTACAO_NO_SELECT_PARA_ESTADO[autoCompensate],
    loaded: opcoes
  }
}

function formataTipoDeContagemDeTempo (rollingWorkHoursBank) {
  const opcoes = [
    { id: 'fixo', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.fixo') },
    { id: 'movel', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.movel') }
  ]
  return {
    loaded: opcoes,
    selected: rollingWorkHoursBank
      ? { id: 'movel', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.movel') }
      : { id: 'fixo', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.fixo') }
  }
}

function temLimite (valor) {
  return valor !== -1
}

function temLimiteAcimaDeZero (valor) {
  return temLimite(valor) && valor !== 0
}

function checaSeUsaLimiteDiario (
  dailyLimitPerHourKind,
  limiteDiarioInferiorPorTipoDeHora,
  apontLimiteDeAcumuloHorasTrabDiaria
) {
  return dailyLimitPerHourKind.some(temLimite) ||
    limiteDiarioInferiorPorTipoDeHora.some(temLimiteAcimaDeZero) ||
    apontLimiteDeAcumuloHorasTrabDiaria?.length > 0
}

export function converteObjetoDoBackParaVuex (regraDeBancoDeHoras) {
  const {
    id,
    // Cabeçalho
    name,
    code,
    dateOfBancoStart,
    numberOfDaysToCompensation,
    numeroDeMesesParaCompensacao,
    vencimentoUnificado,
    rollingWorkHoursBank,
    autoCompensate,
    windowType,
    windowExpirationCycle,
    permitirDescontoEmSaldosVencidos,
    // FatorDeTransformacaoDeHoras
    compensationPerHourKind,
    // RazaoDeAcumuloECompensacao
    splitPerKindOfHour,
    // CompensacaoEmOrdem
    compensacaoEmOrdem,
    separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem,
    ordemDeAcumulos,
    ordemDeCompensacoes,
    // LimitesDiarios
    dailyLimitPerHourKind,
    limiteDiarioInferiorPorTipoDeHora,
    apontLimiteDeAcumuloHorasTrabDiaria,
    valorLimiteDeAcumuloHorasTrabDiaria,
    jornadaBaseLimiteDeAcumuloHorasTrabDiaria,
    // LimitesSemanais
    limiteSemanalSuperiorPorTipoDeHora,
    limiteSemanalInferiorPorTipoDeHora,
    // LimitesMensais
    monthlyLimitPerKindOfHora,
    limiteMensalInferiorPorTipoDeHora,
    // LimitesMensaisSobreaviso
    gruposDeLimiteSobreaviso,
    // LimitesGerais
    generalLimitPerKindOfHora,
    limiteGeralInferiorPorTipoDeHora,
    // Aprovação automática
    isApproved,
    separarCompensacaoEAcumulo,
    // OutrasConfiguracoes
    autoAccTm,
    autoCompStm,
    negativeBalance,
    partialAcc,
    considerarIsTmsAsCompensation,
    descontarBancoSemExibirNaFolha,
    removeLineMeasurement,
    compensateOnLock,
    fazerBaixaNoVencimentoDoBanco,
    completarVisualizacaoDoAcumuladoComJanelasFalsas,
    manterSaldoMensal,
    mudaNomenclaturaParaCompensacaoNaFolha,
    calcularLimitesUtilizandoSaldosFuturos,
    considerarHorasRelogioNoCalculoDeLimiteSemanal,
    exibirFaltaComoCompensadaNoR01,
    exibirBaixaDeBhSeparadaPorCategorias,
    // ConfiguracoesAvancadas
    configBaixaAutomatica
  } = regraDeBancoDeHoras

  const deveSepararHorasExtrasDeSobreaviso = Boolean(
    compensacaoEmOrdem && separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem
  )
  const opcoesDeTipoDeAcumuloDaBaixaDeBh = obterOpcoesDeTipoDeAcumuloDaBaixaDeBh(
    deveSepararHorasExtrasDeSobreaviso
  )

  return {
    id: id,
    // Cabeçalho
    nome: name,
    codigo: code,
    dataInicioDoBanco: converteStringParaDate(dateOfBancoStart),
    limiteDeAcumuloDoBanco: numeroDeMesesParaCompensacao > 0 ? 0 : numberOfDaysToCompensation,
    limiteDeMesesDeAcumuloDoBanco: numeroDeMesesParaCompensacao > 0 ? numeroDeMesesParaCompensacao : 0,
    usaConfiguracaoDeVencimentoPorMeses: numeroDeMesesParaCompensacao > 0,
    vencimentoUnificado: Boolean(vencimentoUnificado),
    tipoDeContagemDeTempo: formataTipoDeContagemDeTempo(rollingWorkHoursBank),
    modalidadeDoBanco: formataModalidadeDoBanco(autoCompensate),
    tipoDoCicloDeAutoCompensacao: formataTipoDoCicloDeAutoCompensacao(windowType),
    quantosCiclosParaVencimento: windowExpirationCycle,
    permitirDescontoEmSaldosVencidos: permitirDescontoEmSaldosVencidos,
    // FatorDeTransformacaoDeHoras
    fatorDeTransformacaoDeHoras: compensationPerHourKind,
    // RazaoDeAcumuloECompensacao
    usaRazaoDeAcumuloECompensacao: splitPerKindOfHour.some(value => value !== 0),
    razaoDeAcumuloECompensacao: splitPerKindOfHour.map(x => (1 - x) * 100),
    // CompensacaoEmOrdem
    usaCompensacaoEmOrdem: Boolean(compensacaoEmOrdem),
    separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem: deveSepararHorasExtrasDeSobreaviso,
    tipoDeAcumuloDaBaixaDeBh: {
      loaded: opcoesDeTipoDeAcumuloDaBaixaDeBh,
      selected: obterCriteriosSelecionados(
        ordemDeAcumulos,
        opcoesDeTipoDeAcumuloDaBaixaDeBh,
        {preservarInvalidos: true}
      )
    },
    tipoDeCompensacaoDaBaixaDeBh: {
      loaded: OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH,
      selected: obterCriteriosSelecionados(
        ordemDeCompensacoes,
        OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH,
        {preservarInvalidos: true}
      )
    },
    // LimitesDiarios
    usaLimiteDiario: checaSeUsaLimiteDiario(
      dailyLimitPerHourKind,
      limiteDiarioInferiorPorTipoDeHora,
      apontLimiteDeAcumuloHorasTrabDiaria
    ),
    limiteDeAcumuloECompensacaoDiario: dailyLimitPerHourKind.map(converteValorMaximo),
    limiteBaseDeAcumuloECompensacaoDiario: limiteDiarioInferiorPorTipoDeHora.map(converteValorMinimo),
    limiteDeAcumuloPorHorasTrabalhadas: {
      seletor: {
        loaded: OPCOES_DE_APONTAMENTOS,
        selected: obterApontamentosSelecionadosLimiteHorasTrabalhadas(apontLimiteDeAcumuloHorasTrabDiaria)
      },
      valor: obterValorLimiteHorasTrabalhadas(valorLimiteDeAcumuloHorasTrabDiaria),
      jornadaBase: obterJornadaBaseLimiteHorasTrabalhadas(jornadaBaseLimiteDeAcumuloHorasTrabDiaria)
    },
    // LimitesSemanais
    usaLimiteSemanal: limiteSemanalSuperiorPorTipoDeHora.some(temLimite) || limiteSemanalInferiorPorTipoDeHora.some(
      temLimiteAcimaDeZero
    ),
    limiteDeAcumuloECompensacaoSemanal: limiteSemanalSuperiorPorTipoDeHora.map(converteValorMaximo),
    limiteBaseDeAcumuloECompensacaoSemanal: limiteSemanalInferiorPorTipoDeHora.map(converteValorMinimo),
    // LimitesMensais
    usaLimiteMensal: monthlyLimitPerKindOfHora.some(temLimite) || limiteMensalInferiorPorTipoDeHora.some(
      temLimiteAcimaDeZero
    ),
    limiteDeAcumuloECompensacaoMensal: monthlyLimitPerKindOfHora.map(converteValorMaximo),
    limiteBaseDeAcumuloECompensacaoMensal: limiteMensalInferiorPorTipoDeHora.map(converteValorMinimo),
    // LimitesMensaisSobreaviso
    usaLimiteMensalSobreaviso: (gruposDeLimiteSobreaviso || []).length > 0,
    limiteMensalSobreaviso: (() => {
      const arr = Array(6).fill(null)
      ;(gruposDeLimiteSobreaviso || []).forEach(g => {
        if (g.indices.length === 1) arr[g.indices[0]] = g.teto
      })
      return arr
    })(),
    gruposDeLimiteSobreaviso: (gruposDeLimiteSobreaviso || [])
      .filter(g => g.indices.length > 1)
      .map(g => ({ indices: g.indices, teto: g.teto === null ? null : g.teto })),
    // LimitesGerais
    usaLimiteGeral: generalLimitPerKindOfHora.some(temLimite) || limiteGeralInferiorPorTipoDeHora.some(
      temLimiteAcimaDeZero
    ),
    limiteDeAcumuloECompensacaoGeral: generalLimitPerKindOfHora.map(converteValorMaximo),
    limiteBaseDeAcumuloECompensacaoGeral: limiteGeralInferiorPorTipoDeHora.map(converteValorMinimo),
    // Aprovação automática
    aprovacaoAutomatica: isApproved,
    separarCompensacaoEAcumulo: separarCompensacaoEAcumulo,
    // OutrasConfiguracoes
    acumularHorasAutomaticamente: autoAccTm,
    compensarHorasAutomaticamente: autoCompStm,
    permitirBalancoNegativo: negativeBalance,
    considerarAcumuloParcialDeHoras: partialAcc,
    considerarBaixaComTmsComoCompensacao: considerarIsTmsAsCompensation,
    descontarBancoSemExibirNaFolha: descontarBancoSemExibirNaFolha,
    removerApontamentosDaLinha: Boolean(removeLineMeasurement),
    compensateOnLock: compensateOnLock,
    fazerBaixaNoVencimentoDoBanco: fazerBaixaNoVencimentoDoBanco,
    completarVisualizacaoDoAcumuladoComJanelasFalsas: completarVisualizacaoDoAcumuladoComJanelasFalsas,
    mostrarHistoricoDosSaldosNoAcumuladoDeBancoDeHoras: manterSaldoMensal,
    mudaNomenclaturaParaCompensacaoNaFolha: mudaNomenclaturaParaCompensacaoNaFolha,
    calcularLimitesUtilizandoSaldosFuturos: calcularLimitesUtilizandoSaldosFuturos,
    considerarHorasRelogioNoCalculoDeLimiteSemanal: considerarHorasRelogioNoCalculoDeLimiteSemanal,
    exibirFaltaComoCompensadaNoR01: exibirFaltaComoCompensadaNoR01,
    exibirBaixaDeBhSeparadaPorCategorias: Boolean(exibirBaixaDeBhSeparadaPorCategorias),
    // ConfiguracoesAvancadas
    usarGatilhoDeSaldoGeral: Boolean(configBaixaAutomatica['gatilho_limite_geral']),
    gatilhoLimiteGeral: configBaixaAutomatica['gatilho_limite_geral'] !== undefined
      ? configBaixaAutomatica['gatilho_limite_geral']
      : 100,
    usarGatilhoDeSaldoMensal: Boolean(configBaixaAutomatica['gatilho_base_mensal']),
    gatilhoBaseMensal: configBaixaAutomatica['gatilho_base_mensal'] !== undefined
      ? configBaixaAutomatica['gatilho_base_mensal']
      : 50,
    camposDesconsideradosDoGatilhoMensal: formataCamposDesconsideradosGatilhoMensal(
      configBaixaAutomatica['apontamentos_desconsiderados_gatilho_mensal']
    )
  }
}
